export default {
  path: "/seller_keys",
  component: () => import("./index.vue"),
  name: "sellerKeys",
  meta: {
    title: "seller_keys.title"
  }
}
